export const ActionTypes = {
  SET_TRANSACTIONS: 'SET_TRANSACTIONS'
};
